import React, { useState, useEffect } from 'react'
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';
import {
    useHistory
} from "react-router-dom";
import { autorizado } from '../navigation/useAuth';
import Telefonos from '../modals/Telefonos';


export default function NavBar() {
    let history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const [cambio, setCambio] = useState(false);
    const [modal, setModal] = useState(false);
    const [admin, setAdmin] = useState(null);

    const toggle = () => setIsOpen(!isOpen);

    const logout = () => {
        sessionStorage.removeItem("login");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("noEmpleado");
        localStorage.removeItem("token");
        localStorage.clear();
        clearInterval();
        //autorizado = false;
        setCambio(!cambio);
        history.goBack();
    };

    const modalOpen = () => {
        setModal(true);
    }
    const modalClose = (e) => {
        setModal(e);
    }

    useEffect(() => {
        setAdmin(sessionStorage.getItem("user"));
    }, [])
    return (
        <div>
            <Navbar
                color="secondary"
                expand="md"
                light
            >
                <NavbarBrand className="mr-auto ms-5">
                    Autorizar Pases
                </NavbarBrand>
                {/* <NavbarToggler onClick={toggle} className="mr-2" /> */}
                <Collapse className="d-flex justify-content-end" isOpen={!isOpen} navbar>
                    <Nav navbar>
                        {admin === "SIRADAME" || admin === "SIRADAMEME"
                            &&
                            <NavItem>
                                <NavLink onClick={modalOpen}>Añadir Telefono</NavLink>
                            </NavItem>
                        }
                        <NavItem>
                            <NavLink onClick={logout}>Cerrar Sesion</NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Navbar>
            <Telefonos modal={modal} modalClose={modalClose} />
        </div>
    )
}
